// React Core Imports
import { useState } from 'react'
import { NavLink } from 'react-router-dom'

// Components & Data Imports
import logo from '../resources/imgs/logo_alt.webp'

const Navigation = () => {
  const [open, setOpen] = useState(false)
  const closeMenu = () => setOpen(false)

  return (
    <div className='navbar'>
      <NavLink to='/'>
        <img src={logo} alt='' className='navbar-logo' />
      </NavLink>

      {/* Desktop menu */}
      <div className='navbar-menu'>
        <NavLink
          to='/'
          end
          className={({ isActive }) =>
            `navbar-menu-item ${isActive ? 'navbar-menu-item-active' : ''}`
          }
        >
          Ročník 2026
        </NavLink>

        <NavLink
          to='/aktuality'
          className={({ isActive }) =>
            `navbar-menu-item ${isActive ? 'navbar-menu-item-active' : ''}`
          }
        >
          Aktuality
        </NavLink>

        <NavLink
          to='/galerie'
          className={({ isActive }) =>
            `navbar-menu-item ${isActive ? 'navbar-menu-item-active' : ''}`
          }
        >
          Galerie
        </NavLink>

        <NavLink
          to='/historie'
          className={({ isActive }) =>
            `navbar-menu-item ${isActive ? 'navbar-menu-item-active' : ''}`
          }
        >
          Historie
        </NavLink>

        <NavLink
          to='/kontakty'
          className={({ isActive }) =>
            `navbar-menu-item ${isActive ? 'navbar-menu-item-active' : ''}`
          }
        >
          Kontakty
        </NavLink>
      </div>

      {/* Hamburger (mobile) */}
      <button
        className={`navbar-burger ${open ? 'is-open' : ''}`}
        aria-label={open ? 'Zavřít menu' : 'Otevřít menu'}
        aria-expanded={open}
        onClick={() => setOpen(v => !v)}
        type='button'
      >
        <span />
        <span />
        <span />
      </button>

      {/* Mobile menu panel */}
      <div className={`navbar-mobile ${open ? 'is-open' : ''}`}>
        <NavLink to='/' end onClick={closeMenu} className='navbar-mobile-item'>
          Ročník 2026
        </NavLink>
        <NavLink
          to='/aktuality'
          onClick={closeMenu}
          className='navbar-mobile-item'
        >
          Aktuality
        </NavLink>
        <NavLink
          to='/galerie'
          onClick={closeMenu}
          className='navbar-mobile-item'
        >
          Galerie
        </NavLink>
        <NavLink
          to='/historie'
          onClick={closeMenu}
          className='navbar-mobile-item'
        >
          Historie
        </NavLink>
        <NavLink
          to='/kontakty'
          onClick={closeMenu}
          className='navbar-mobile-item'
        >
          Kontakty
        </NavLink>
      </div>

      {/* Klikací overlay pro zavření */}
      {open && <div className='navbar-overlay' onClick={closeMenu} />}
    </div>
  )
}

export default Navigation
